module.exports = __webpack_public_path__ + "static/media/Rectangle 77.ebc807da.png";